import React, { Component } from 'react';
import styles from './Article.module.css';

export default class Article extends Component {
    render() {
        return (
            <article className={styles.Article}>
                <h1>{this.props.title}</h1>
                {this.props.children}
            </article>
        )
    }
}
